// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RefreshOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M17.65 6.35A7.96 7.96 0 0012 4a7.99 7.99 0 107.73 10h-2.08a5.99 5.99 0 11-1.43-6.22L13 11h7V4l-2.35 2.35z","fill":"currentColor"}}]},"name":"refresh","theme":"outlined"};

const RefreshOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RefreshOutlinedSvg} />;
  RefreshOutlined.displayName = 'RefreshOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RefreshOutlined);
